import {createAction, props} from '@ngrx/store';
import {NewsDTO, PageableDTO} from '../../../../openapi/agrarinformationen-openapi';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';


export class OverviewActions {

  private static readonly prefix = '[Overview] ';

  public static readNews = createAction(
    this.prefix + 'Read News.',
    props<{ pageableDto?: PageableDTO }>(),
  );

  public static readNewsSuccess = createAction(
    this.prefix + 'Set news ids that should be displayed at news component.',
    props<{ newsDtos: NewsDTO[], totalElements: number }>(),
  );

  public static readNewsFailure = createAction(
    this.prefix + 'Failed to read news.',
    props<{ error: MappedHttpErrorResponse }>(),
  );

  public static changePageable = createAction(
    this.prefix + 'Changed pageable.',
    props<{ pageableDto: PageableDTO }>(),
  );

}
